/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './product-listing-page.module';
export { PRODUCT_LISTING_URL_MATCHER } from './product-listing-url-matcher';
